import { render, staticRenderFns } from "./ParametricArticleBuilder.vue?vue&type=template&id=503a9a4c&scoped=true&"
import script from "./ParametricArticleBuilder.vue?vue&type=script&lang=js&"
export * from "./ParametricArticleBuilder.vue?vue&type=script&lang=js&"
import style0 from "./ParametricArticleBuilder.vue?vue&type=style&index=0&id=503a9a4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503a9a4c",
  null
  
)

export default component.exports